import rfdc from "rfdc";

const doClone = rfdc();

export function clone<T>(input: T): T {
  return doClone(input);
}
